var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMessagesPicker = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.98555 6.6665C8.14461 6.6665 6.65222 8.15889 6.65222 9.99984C6.65222 11.8408 8.14461 13.3332 9.98555 13.3332C11.8265 13.3332 13.3189 11.8408 13.3189 9.99984C13.3189 9.11578 12.9677 8.26794 12.3426 7.64281C11.7175 7.01769 10.8696 6.6665 9.98555 6.6665Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 16.2332C12.9341 17.0601 11.483 17.5007 9.99873 17.4987L10.0001 17.5001C7.97406 17.5 6.03425 16.6804 4.6221 15.2276C3.20995 13.7749 2.4456 11.8126 2.50302 9.78743C2.65574 5.82934 5.82934 2.65574 9.78743 2.50302C11.8126 2.4456 13.7749 3.20995 15.2276 4.6221C16.6804 6.03425 17.5 7.97406 17.5001 10.0001V11.2501C17.5001 11.8026 17.2806 12.3325 16.8899 12.7232C16.4992 13.1139 15.9693 13.3334 15.4167 13.3334V13.3334C14.2661 13.3334 13.3334 12.4007 13.3334 11.2501V6.66672",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMessagesPicker);
export default ForwardRef;